import React from 'react';
import { useMutation } from '@apollo/client';
import { useHistory, Link } from 'react-router-dom';
import { Breadcrumb, message } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import {
  ADD_PROJECT_STATUS,
  GET_PROJECT_STATUS,
} from '../../../gql/projectStatus';
import ProjectStatusForm from './components/ProjectStatusForm';

const AddProjectStatus = () => {
  const history = useHistory();
  const [addProjectStatus] = useMutation(ADD_PROJECT_STATUS, {
    refetchQueries: [
      { query: GET_PROJECT_STATUS, variables: { state: 'ALL' } },
      { query: GET_PROJECT_STATUS, variables: { state: 'ACTIVE' } },
    ],
    onCompleted: ({ addProjectStatus }) => {
      history.push('/system-setting/project-status');
      message.success(
        `Project Status ${addProjectStatus.name} successfully added`
      );
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const onFinish = async (input) => {
    await addProjectStatus({
      variables: {
        input,
      },
    });
    return true;
  };

  return (
    <PageContainer
      header={{
        title: 'Add Project Status',
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/project-status">Project Status</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Add Project Status</Breadcrumb.Item>
          </Breadcrumb>
        ),
      }}
    >
      <ProjectStatusForm onFinish={onFinish} />
    </PageContainer>
  );
};

export default AddProjectStatus;
